import React from 'react'

const Titles = ({field}) => {
  return (
    <label className="font-bold block mb-[1rem]">
    <span className="text-terciaria">{`${field.id})`}.</span> {field.label}{" "}
    {field.required && <span className="text-[#ff0000]">*</span>}
  </label>
  )
}

export default Titles